import styled from 'styled-components'

export const PanelContainer = styled.div`
  width: 260px;
  height: 100%;
  background: white;
  border-right: 1px solid #e1e5e9;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

export const PanelHeader = styled.div`
  padding: 16px;
  border-bottom: 1px solid #e1e5e9;
  background: #f8f9fa;
`

export const PanelTitle = styled.h3`
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`

export const SearchInput = styled.input`
  width: calc(100% - 32px);
  margin: 16px;
  padding: 8px 12px;
  border: 1px solid #e1e5e9;
  border-radius: 4px;
  font-size: 13px;
  outline: none;
  transition: border-color 0.2s;

  &:focus {
    border-color: #007bff;
  }

  &::placeholder {
    color: #9ca3af;
  }
`

export const ElementList = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 8px 16px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`

export const CategorySection = styled.div`
  margin-bottom: 8px;
`

export const CategoryHeader = styled.div<{ isCollapsed: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: #f8f9fa;
  border-radius: 4px;
  cursor: pointer;
  user-select: none;
  font-size: 12px;
  font-weight: 600;
  color: #4a5568;
  margin: 8px 0 4px;
  transition: background-color 0.2s;

  &:hover {
    background: #e9ecef;
  }
`

export const CollapseIcon = styled.span<{ isCollapsed: boolean }>`
  transform: ${props => props.isCollapsed ? 'rotate(-90deg)' : 'rotate(0deg)'};
  transition: transform 0.2s;
  font-size: 10px;
`

export const ElementItem = styled.div.attrs<{ isSelected: boolean; isHovered: boolean }>({})`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  margin: 2px 0;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.2s;
  background: ${props =>
    props.isSelected ? '#e3f2fd' :
    props.isHovered ? '#f5f5f5' :
    'transparent'
  };
  border: 1px solid ${props =>
    props.isSelected ? '#90caf9' :
    'transparent'
  };

  &:hover {
    background: ${props => props.isSelected ? '#e3f2fd' : '#f5f5f5'};
  }
`

export const ElementIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin-right: 8px;
  font-size: 14px;
  color: #6b7280;
  flex-shrink: 0;
`

export const ElementName = styled.span`
  flex: 1;
  color: #1a1a1a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 4px;
`

export const ElementInfo = styled.span`
  font-size: 11px;
  opacity: 0.6;
  color: #6b7280;
  flex-shrink: 0;
`

export const VisibilityToggle = styled.button<{ isVisible: boolean }>`
  background: none;
  border: none;
  padding: 2px;
  cursor: pointer;
  font-size: 14px;
  opacity: ${props => props.isVisible ? 1 : 0.4};
  transition: opacity 0.2s;

  &:hover {
    opacity: 1;
  }
`

export const EmptyState = styled.div`
  text-align: center;
  padding: 32px 16px;
  color: #9ca3af;
  font-size: 13px;
`